export interface GalleryImage {
  src: string
  alt: string
  /** Frame type this image belongs to */
  category: string
}

export interface GalleryCategory {
  id: string
  label: string
  description: string
}

export const GALLERY_CATEGORIES: GalleryCategory[] = [
  {
    id: 'felon-i',
    label: 'Felon I',
    description: 'Coming soon. Downhill race platform.',
  },
  {
    id: 'raptor-i',
    label: 'Raptor I',
    description: 'Enduro platform. The current photographed Burton bike.',
  },
  {
    id: 'typhoon-i',
    label: 'Typhoon I',
    description: 'Coming soon. Down-country platform.',
  },
  {
    id: 'raider',
    label: 'Raider',
    description: 'Coming soon. E-Enduro platform.',
  },
]

export const GALLERY_IMAGES: GalleryImage[] = [
  { src: '/images/bike-lines/hidden-felon.png', alt: 'Felon I hidden placeholder', category: 'felon-i' },
  { src: '/images/raptor/raptor-porsche-sunset.png', alt: 'Raptor I - private collection, Central Otago', category: 'raptor-i' },
  { src: '/images/raptor/raptor-frame-render.png', alt: 'Raptor I - bare chassis, woven carbon and additive lugs', category: 'raptor-i' },
  { src: '/images/raptor/raptor-pagani-lakeside.png', alt: 'Raptor I - lakeside, in fitting company', category: 'raptor-i' },
  { src: '/images/burton-tuatara-rs0002.jpg', alt: 'Raptor I - studio',          category: 'raptor-i' },
  { src: '/images/burton-tuatara-rs0008.jpg', alt: 'Raptor I - cockpit detail',  category: 'raptor-i' },
  { src: '/images/burton-tuatara-rs0016.jpg', alt: 'Raptor I - suspension detail', category: 'raptor-i' },
  { src: '/images/file_0000000075f0720985ca15531d9ccf9e.png', alt: 'Raptor I - trail render', category: 'raptor-i' },
  { src: '/images/file_00000000d23471fa826524275f2b133a(2)(1).png', alt: 'Raptor I - side profile render', category: 'raptor-i' },
  { src: '/images/bike-lines/hidden-typhoon.png', alt: 'Typhoon I hidden placeholder', category: 'typhoon-i' },
  { src: '/images/bike-lines/hidden-raider.png', alt: 'Raider hidden placeholder', category: 'raider' },
]
